// extracted by mini-css-extract-plugin
export default {"container":"style_container__RU3yn","cardChild":"style_cardChild__PV6fg","formStyle":"style_formStyle__eI-cl","footer":"style_footer__DV8Q5"};